// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".license[data-v-51b75b36]{padding-bottom:1rem}.license h1[data-v-51b75b36]{font-size:.3rem;text-align:center;margin:.6rem 0 .3rem}.license img[data-v-51b75b36]{display:block;width:6.8rem;margin:0 auto}.license .footer[data-v-51b75b36]{position:fixed;width:100%;text-align:center;bottom:.4rem}.license .footer .net-num[data-v-51b75b36]{font-size:.26rem;margin-top:.04rem;color:#9da0a3}", ""]);
// Exports
module.exports = exports;
